import _extends from '@babel/runtime/helpers/extends';
import React__default, { useRef, useState } from 'react';
import styled from 'styled-components';
import { TaktIdProvider, createStormTaktId, useIsMobile, TextButton, Button, Tooltip, Sheet } from '@amzn/storm-ui';
import { g as getTranslationComponent } from '../../../i18n/PageHeaderTranslation/index-D-JlEl92.js';
import { I as IntlProvider } from '../../../LocalModules/storm-ui-intl/dist/esm/IntlProvider-DUNZ897o-Dn-1_05J.js';
import { u as useIntl } from '../../../LocalModules/storm-ui-intl/dist/esm/3rdPartyModules/react-intl/lib/src/components/useIntl-voJ4yxcS-DU7lWLPF.js';

const DisabledButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-40025937__sc-ldnacm-0"
})(["border-radius:", ";"], ({
  theme
}) => theme.button.borderRadius);
const LocalizedButtonAction = ({
  label,
  variant = 'default',
  tooltipContent,
  tooltipPosition = 'top',
  nonInteractiveTooltip,
  ...rest
}) => {
  const {
    formatMessage
  } = useIntl();
  const isMobile = useIsMobile();
  const toggleElRef = useRef(null);
  const [isSheetOpen, setIsSheetOpen] = useState(false);
  const handleClose = () => {
    setIsSheetOpen(false);
  };
  const handleClick = () => isMobile && setIsSheetOpen(true);
  const handleKeyDown = event => {
    if (isMobile && ['Enter', ' '].includes(event.key)) {
      event.preventDefault();
      setIsSheetOpen(true);
    }
  };
  const ButtonComponent = variant === 'link' ? /*#__PURE__*/React__default.createElement(TextButton, _extends({}, rest, {
    variant: "default",
    style: rest.disabled ? {
      pointerEvents: 'none'
    } : {}
  }), label) : /*#__PURE__*/React__default.createElement(Button, _extends({}, rest, {
    variant: variant,
    style: rest.disabled ? {
      pointerEvents: 'none'
    } : {}
  }), label);
  if (!tooltipContent) {
    return ButtonComponent;
  }
  const wrappedButton = /*#__PURE__*/React__default.createElement(DisabledButtonWrapper, {
    tabIndex: 0,
    "aria-disabled": "true",
    "aria-label": label,
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: toggleElRef,
    "data-testid": "page-header-button-wrapper"
  }, ButtonComponent);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, !isMobile && /*#__PURE__*/React__default.createElement(Tooltip, {
    position: tooltipPosition,
    nonInteractive: nonInteractiveTooltip,
    withCloseButton: false,
    trigger: wrappedButton
  }, tooltipContent), isMobile && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, wrappedButton, /*#__PURE__*/React__default.createElement(Sheet, {
    isOpen: isSheetOpen,
    onClose: handleClose,
    sheetElementId: "portal",
    closeButton: {
      type: 'icon',
      label: formatMessage({
        id: 'close-label'
      })
    },
    toggleEl: toggleElRef
  }, tooltipContent)));
};
const ButtonAction = ({
  locale = 'en-US',
  taktId,
  taktValue,
  ...rest
}) => /*#__PURE__*/React__default.createElement(TaktIdProvider, {
  taktId: taktId,
  taktValue: taktValue,
  fallbackId: createStormTaktId('page-header-popover-action')
}, /*#__PURE__*/React__default.createElement(IntlProvider, {
  resetKey: locale,
  translations: getTranslationComponent(locale)
}, /*#__PURE__*/React__default.createElement(LocalizedButtonAction, rest)));

export { ButtonAction as B };
//# sourceMappingURL=ButtonAction-C1uEqLHU.js.map
